import styles from "./AvatarLetter.module.css";

const colors = ["#f44336", "#e91e63", "#3f51b5"];

interface Props {
  name?: string;
  size?: number;
}

export default function AvatarLetter({ name, size = 44 }: Props) {
  const index = (name?.length ?? 0) % colors.length;

  return (
    <span
      className={styles.AvatarLetter}
      style={{
        width: size,
        height: size,
        fontSize: size / 3,
        background: colors[index],
      }}
    >
      {name?.[0] ?? "A"}
    </span>
  );
}
